import { Link } from "react-router-dom";
import FirebaseAuth from "src/components/FirebaseAuth";
import { useTranslation } from "react-i18next";
import { themeStyle, getDomainMeta } from "src/themes";
import { loginWithFacebook } from "src/services/firebase";
import ArtistModal from "src/components/ArtistModal";
import { useState, useRef, useEffect } from "react";
import LanguageSelector from "src/templates/Basic/components/forms/LanguageSelector";
import Hero from "src/components/Hero";
import MultiUser from "src/components/MultiUser";
import FooterSection from "src/components/FooterSection";

function Landing(props) {
  const { t } = useTranslation();
  const ref = useRef(null);
  const { appData } = props;
  let domainMeta = getDomainMeta();
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    const handleOutSideClick = (event) => {
      if (!ref.current?.contains(event.target)) {
        setIsModalOpen(false);
      }
    };
    ["mousedown", "scroll"].forEach((event) =>
      window.addEventListener(event, handleOutSideClick)
    );
    return () => {
      ["mousedown", "scroll"].forEach((event) =>
        window.addEventListener(event, handleOutSideClick)
      );
    };
  }, [ref]);

  return (
    // <div>
    //   <div
    //     className="start"
    //     style={{ backgroundImage: `url(${domainMeta.landingImage})` }}
    //   >
    //     <div className="container max-w-[100%] p-0">
    //       <div className="phone:bg-white sm:bg-transparent phone:px-3">
    //         <div className="flex justify-between items-center relative py-2 px-0">
    //           <div>
    //             <a
    //               href="/"
    //               aria-label="Company"
    //               title="Company"
    //               className="indivne-flex items-center"
    //             >
    //               <img
    //                 src={`https://mazutech.online/${appData.communityMeta?.logo}`}
    //                 alt=""
    //                 className="object-cover w-32"
    //               />
    //             </a>
    //           </div>
    //           <div className="flex items-center gap-2 justify-end">
    //             <Link to="/login" className="btn btn-custom btn-red btn-red-login">
    //               {t("Login")}
    //             </Link>
    //             <div className="flex items-center">
    //               <LanguageSelector />
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //       <div className="row align-items-center justify-content-center">
    //         <div className="col-md-4">
    //           <div className="start_content">
    //             <Link to="/register" className="btn btn-custom btn-red">
    //               <div className="border">
    //                 <i className="fa fa-envelope" />
    //               </div>
    //               <span>{t("Register")}</span>
    //             </Link>
    //             {/* <a
    //               href="#"
    //               className="btn btn-custom btn-fb"
    //               onClick={async () => loginWithFacebook()}
    //             >
    //               <div className="border">
    //                 <img src="https://paarfever.com/pic/fb.png" />
    //               </div>
    //               <span>{t("LoginWithFacebook")}</span>
    //             </a>
    //               <span>{t('LoginWithFacebook')}</span>
    //             </a> */}
    //             <FirebaseAuth />
    //             <a href="#" className="btn btn-custom">
    //               <img
    //                 src="https://paarfever.com/pic/button_playstore.png"
    //                 style={{ width: "100%" }}
    //               />
    //             </a>
    //             <div className="testi">
    //               <div className="row">
    //                 <div className="col-2">
    //                   <img src="https://paarfever.com/pic/user.jpg" />
    //                 </div>
    //                 <div className="col-10">
    //                   <div className="white-box">
    //                     <strong>{t("testimonial_julia_name")}</strong>
    //                     <br />
    //                     <span className="text-sm">
    //                       {t("testimonial_julia")}
    //                     </span>
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>

    //   <Link
    //     style={{ background: "#FF3131", zIndex: 1000 }}
    //     className="fixed top-[100px] text-sm sm:text-base right-10 transform rounded-t-3xl  -rotate-90 origin-top-right text-white px-2 py-2"
    //     onClick={() => setIsModalOpen(true)}
    //   >
    //     {t("ARTIST WANTED")}
    //   </Link>

    //   <div className="iconBox margin">
    //     <i className="fa fa-handshake" />
    //   </div>
    //   <div className="now redBack section">
    //     <div className="container">
    //       <div className="row align-items-center justify-content-center">
    //         <h2>{t("Authentic Connections")}</h2>
    //         {t("Authentic Connections Text")}
    //       </div>
    //     </div>
    //   </div>
    //   <div className="iconBox margin interactive-features">
    //     <i className="fa fa-comments" />
    //   </div>
    //   <div className="now redBack section">
    //     <div className="container">
    //       <div className="row align-items-center justify-content-center">
    //         <h2>{t("Interactive Features")}</h2>
    //         {t("Interactive Features Text")}
    //       </div>
    //     </div>
    //   </div>
    //   <div className="why section  perfect-bal">
    //     <div className="container">
    //       <div className="row align-items-center justify-content-center">
    //         <div className="col-md-8">
    //           <div className="iconBox">
    //             <img src="https://paarfever.com/pic/smile.png" />
    //           </div>
    //           <h2 className="mt-4">{t("Perfect Balance")}</h2>
    //           {t("Perfect Balance Text")}
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <div className="iconBox margin Unmatched-Dating">
    //     <i className="fa fa-film"></i>
    //   </div>
    //   <div className="nowreg redBack section">
    //     <div className="container">
    //       <div className="row justify-content-center align-items-center">
    //         <div className="">
    //           <h2>{t("Unmatched Dating & Entertainment")}</h2>
    //           {t("Unmatched Dating & Entertainment Text")}
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <footer className="bg-white py-10">
    //     <div className="container mx-auto text-center">
    //       <div className="mb-4">
    //         <a
    //           href="https://web.facebook.com/flirttoolprime?_rdc=1&_rdr"
    //           target="_blank"
    //           rel="noopener noreferrer"
    //           className="mx-3 transition-colors duration-300"
    //         >
    //           <i
    //             className="fab fa-facebook text-2xl"
    //             style={{ color: themeStyle.background }}
    //           ></i>
    //         </a>
            // <a
            //   href="https://www.instagram.com/flirttoolprime/"
            //   target="_blank"
            //   rel="noopener noreferrer"
            //   className="mx-3 transition-colors duration-300"
            // >
            //   <i
            //     className="fab fa-instagram text-2xl"
            //     style={{ color: themeStyle.background }}
            //   ></i>
            // </a>
    //       </div>
    //       <div className="text-sm text-gray-500">
    //         <Link to="/imprint" className="mx-2 hover:underline">
    //           {t("Impressum")}{" "}
    //         </Link>
    //         <Link to="/privacy" className="mx-2 hover:underline">
    //           {t("Datenschutz")}
    //         </Link>
    //         <Link to="/terms" className="mx-2 hover:underline">
    //           {t("AGB")}
    //         </Link>
    //         <Link to="/customer">{t("Kundensupport")}</Link>
    //       </div>
    //       <div className="text-xs text-gray-600 mt-4">{t("footerNote")}</div>
    //     </div>
    //   </footer>

    //   <div >
    //     {isModalOpen && (
    //       <ArtistModal
    //         isOpen={isModalOpen}
    //         onClose={() => setIsModalOpen(false)}
    //         ref={ref}
    //       />
    //     )}
    //   </div>
    // </div>
    <>
    
      <Hero />
      <MultiUser />
      <FooterSection />
    </>
  );
}

export default Landing;
